// Mirrors the breakpoints in css/_variables.scss. Change both together.
export const breakpoints = { sm: 768, md: 992, lg: 1200 } as const;

export type Breakpoint = keyof typeof breakpoints;

export const minWidth = (breakpoint: Breakpoint) =>
  `(min-width: ${breakpoints[breakpoint]}px)`;
